module.exports = __webpack_public_path__ + "img/relationship.71cdb797.svg";